function DeferredDataScripts_default() {
  return null;
}
;
export {
  DeferredDataScripts_default as default
};
